import axios from "axios";
import { getCookie } from "../getcookie";

const defaultHeaders = () => ({
    "Content-Type": "application/json; charset=UTF-8",
    Accept: "application/json",
    Authorization: getCookie("mawalog"),
});

export const getApi = async (endpoint, params = {}, headers = {}) => {
    try {
        const response = await axios.get(`${endpoint}`, {
            params,
            headers: {
                ...defaultHeaders(),
                ...headers,
            },
        });
        return response;
    } catch (error) {
        console.error(`GET API Error [${endpoint}]:`, error);
        throw error;
    }
};

export const deleteApi = async (endpoint, params = {}, headers = {}) => {
    try {
        const response = await axios.delete(`${endpoint}`, {
            params,
            headers: {
                ...defaultHeaders(),
                ...headers,
            },
        });
        return response;
    } catch (error) {
        console.error(`DELETE API Error [${endpoint}]:`, error);
        throw error;
    }
};

export const postApi = async (endpoint, data = {}, headers = {}) => {
    try {
        const response = await axios.post(`${endpoint}`, data, {
            headers: {
                ...defaultHeaders(),
                ...headers,
            },
        });
        return response;
    } catch (error) {
        console.error(`POST API Error [${endpoint}]:`, error);
        throw error;
    }
};

export const putApi = async (endpoint, data = {}, headers = {}) => {
    try {
        const response = await axios.put(`${endpoint}`, data, {
            headers: {
                ...defaultHeaders(),
                ...headers,
            },
        });
        return response;
    } catch (error) {
        console.error(`PUT API Error [${endpoint}]:`, error);
        throw error;
    }
};
